export default __webpack_public_path__ + "static/solution-img-f123d1087145af11b784b00ac7cd3ace.webp";